export default "__VITE_ASSET__B3PnoUij__"